import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        canManageCourse: '=',
        course: '='
    },
    template: `
        <div class="well color02">
            <div class="heading01">
                <h1>{{ 'course.Versions' | translate }}</h1>
            </div>
            <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
            <div class="tablewrapper">
                <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length">
                    <thead>
                        <tr>
                            <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'version.Version name' | translate }}</a></th>
                            <th>{{ 'version.Training count' | translate }}</th>
                            <th>{{ 'version.Associated occurrences' | translate }}</th>
                            <th>{{ 'version.Created' | translate }}</th>
                            <th>{{ 'version.Last modified' | translate }}</th>
                            <th class="actions">&nbsp</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-class="{status04: item.isArchived}" ng-repeat="item in vm.list.items">
                            <td>
                                <a ui-sref="authorized.courses.courses.edit.version.edit.training({ id: item.courseId, versionId: item.id })">{{ item.name }}</a>
                                <small ng-if="item.isArchived">({{ 'version.Archived' | translate }})</small>
                            </td>
                            <td>{{ item.courseTrainings.length }}</td>
                            <td>
                                <span ng-if="!item.isWithoutPlanning">{{ item.courseOccurrences.length }}</span>
                                <span ng-if="item.isWithoutPlanning">{{ 'version.Without planning' | translate }}</span>
                            </td>
                            <td>{{ vm.MomentService.formatTimeStamp(item.createdAt) }}</td>
                            <td>{{ vm.MomentService.formatTimeStamp(item.updatedAt) }}</td>
                            <td class="actions">
                                <a ui-sref="authorized.courses.courses.edit.version.edit.training({ id: item.courseId, versionId: item.id })"
                                class="btn edit" >
                                    <span ng-if="vm.canManageCourse">{{ 'general.Edit' | translate }}</span>
                                    <span ng-if="!vm.canManageCourse">{{ 'general.View' | translate }}</span>
                                </a>
                                <a class="btn ico-copy"
                                    ng-if="vm.canManageCourse && !vm.course.isArchived"
                                    ng-click="vm.copy(item)"
                                >{{ 'general.Copy' | translate }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
            </div>
        </div>
    `
})

export default class {
    constructor ($state, DATATABLES, ListFactory, CourseVersionResource, MomentService, ModalService) {
        this.$state = $state;
        this.DATATABLES = DATATABLES;
        this.CourseVersionResource = CourseVersionResource;
        this.MomentService = MomentService;
        this.ModalService = ModalService;

        this.list = ListFactory.createWithPagination(CourseVersionResource.query.bind(CourseVersionResource));
    }

    fetch () {
        this.list.fetch({
            courseId: this.$state.params.id,
            withoutPlanningIncluded: true,
            expand: 'courseOccurrences,courseTrainings'
        });
    }

    $onInit () {
        this.fetch();
    }

    copy (version) {
        return this.ModalService.open({
            template: `
                <modals-courses-version-copy
                    uib-modal-instance="vm.$uibModalInstance"
                    version-id="vm.versionId"
                    course-id="vm.courseId"
                    version-name="vm.versionName"
                    is-course-with-materials="vm.isCourseWithMaterials"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance, COURSE_TRAINING_TYPE_ENUM) {
                this.$uibModalInstance = $uibModalInstance;
                this.versionId = version.id;
                this.courseId = version.courseId;
                this.versionName = version.name;
                this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;

                this.isCourseWithMaterials = version.courseTrainings.some(training => {
                    return training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST;
                });
            }
        }).then(v => {
            this.$state.go('authorized.courses.courses.edit.version.edit.training', {
                id: v.courseId,
                versionId: v.id
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/version/list/index.js